import { Modal, ModalOverlay, ModalContent, Image, CloseButton, Box, Link } from "@chakra-ui/react";
import bondaDetalle from "../assets/palomma-plus-popup-bonda-detalle.png";

interface BondaDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const BondaDetailModal = ({ isOpen, onClose }: BondaDetailModalProps): JSX.Element => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="l" isCentered>
      <ModalOverlay />
      <ModalContent position="relative" boxShadow="none" maxW="fit-content" overflow="hidden" p={0}>
        <Box position="relative">
          <Image
            src={bondaDetalle}
            alt="Bonda Beneficios Detalle"
            maxHeight="70vh"
            height="auto"
            width="auto"
            maxWidth="70vw"
            display="block"
          />
          <CloseButton
            position="absolute"
            right={2}
            top={2}
            zIndex={1}
            color="purple.500"
            _hover={{ color: "purple.400" }}
            _focus={{ boxShadow: "none" }}
            onClick={onClose}
            size="sm"
          />
        </Box>
        <Box bg="white" p={4} display="flex" justifyContent="center">
          <Link
            href="https://palommaplus.com"
            isExternal
            color="purple.500"
            textDecoration="underline"
            fontSize="0.85rem"
            fontWeight={600}
          >
            Ver más marcas aliadas
          </Link>
        </Box>
      </ModalContent>
    </Modal>
  );
};

export default BondaDetailModal;
